<template>
  <div class="interview-footer__container">
    <div v-if="options.length > 0" class="interview-footer__options-container">
      <button
        v-for="{ id, displayText, selected } in options"
        :key="id"
        :class="{
          'interview-footer__option': true,
          'interview-footer__option--selected': selected,
          'interview-footer__option--rtl': isRtl,
        }"
        :data-test-id="`InterviewFooter_SpecialOption-${id}`"
        role="option"
        :aria-selected="selected"
        @click="() => $emit('toggleOption', id)"
      >
        {{ displayText }}
      </button>
    </div>
    <button
      class="interview-footer__continue-button"
      :disabled="!canSubmit || isLoading"
      data-test-id="InterviewFooter_ContinueButton"
      @click="$emit('continue')"
    >
      <div v-if="isLoading" class="interview-footer__continue-button-spinner" />
      <p v-else>
        {{ submitText }}
      </p>
    </button>
  </div>
</template>
<script lang="ts">
import { defineComponent, type PropType } from 'vue'

import { isRtlLocale } from '../../../intl'

export default defineComponent({
  props: {
    options: {
      type: Array as PropType<{ id: string; displayText: string; selected: boolean }[]>,
      default: () => [],
    },
    submitText: {
      type: String,
      required: true,
    },
    canSubmit: {
      type: Boolean,
      default: true,
    },
    isLoading: {
      required: true,
      type: Boolean,
    },
  },
  emits: {
    continue: () => true,
    toggleOption: (_optionId: string) => true,
  },

  setup() {
    return { isRtl: isRtlLocale() }
  },
})
</script>
<style lang="postcss">
.interview-footer {
  &__container {
    display: flex;
    flex-direction: column;
  }

  &__options-container {
    display: flex;
    justify-content: space-between;
  }

  &__input--hidden {
    display: none;
  }

  &__option {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    border: 1px solid var(--color-blue-grey);
    border-right: 0;
    background-color: white;
    color: var(--color-text-button);
    cursor: pointer;
    transition: background 0.12s;

    &--selected {
      border-top-color: var(--color-selected);
      border-bottom-color: var(--color-selected);
      background-color: var(--color-selected);
      color: white;
    }

    &:first-child {
      border-left: 0;
    }

    &--rtl {
      &:first-child {
        border-right: 0;
        border-left: 1px solid var(--color-blue-grey);
      }

      &:last-child {
        border-left: 0;
      }
    }
  }

  &__continue-button {
    padding: 1rem;
    border: 0;
    background-color: var(--color-success);
    color: white;
    cursor: pointer;

    &:disabled {
      background-color: var(--color-blue-grey);
      color: var(--color-disabled-text);
    }
  }

  &__continue-button-spinner {
    width: 16px;
    height: 16px;
    border: white 2px solid;
    border-radius: 100%;
    border-right: transparent 2px solid;
    margin: auto;
    animation: spin 0.5s infinite ease-in-out;
  }
}
</style>
